import { CartItem } from './cart';

export enum OrderStatus {
  PENDING = 'pending',
  PROCESSING = 'processing',
  SHIPPED = 'shipped',
  DELIVERED = 'delivered',
  CANCELLED = 'cancelled',
}

export interface Order {
  id: string;
  userId: string;
  items: CartItem[];
  totalAmount: number;
  status: OrderStatus;
  orderDate: Date;
  shippingAddress: string;
  customerName: string;
  customerEmail: string;
  customerPhone: string | null;
  paymentIntentId: string | null;
}
